import React, {useEffect, useState} from 'react'
import FailedModal from "../../CustomModal/Failed";
import Loader from "../../../Loader/Loader";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import FileUpload from "../../FileUploads/FileUpload";
import SuccessModal from "../../CustomModal/Success";
import {toast} from "react-toastify";
import DashboardMenu from "../../layout/dashboardMenu";



const PostClosure = ({
                         documentUploadUrlPublic,
                         documentUrlDataPublic,
                         history,
                         accountDetailsById,
                         accountDetails=[],
                         match,
                         savePostClosure,
                         postClosureDetails=[]
                     }) => {

    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });

    const [inputList, setInputList] = useState([{
        activity_date: '',
        meta_data: {},
        lat: '',
        long: '',
        desc:'',
        project_type:'',
        opportunity_id:''
    }])
    const [successMessage, setSuccessMessage] = useState('')
    const [isAllow, setIsAllow] = useState(false);
    const [projectType, setProjectType] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await accountDetailsById(match?.params?.account_id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        if(Object.keys(accountDetails).length > 0 && accountDetails?.project_name !== undefined) {
            let projectName =  accountDetails?.project_name === "Public Parking" ? "Parking" : accountDetails?.project_name
            console.log(projectName)
            setProjectType(projectName)
        }
    }, [accountDetails])

    const handleInput = (key, val, metaKey = '', e = '') => {
        let list = [...inputList]
        if (key === 'meta_data') {
            inputList[0][key][metaKey] = val
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        list['project_type'] = projectType
        list['opportunity_id'] = match?.params?.opportunity_id
        list['account_id'] = match?.params?.account_id

        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }
        if (match?.params?.lead_id !== undefined) {
            list['lead_id'] = match?.params?.lead_id
        }

        // console.log(list)
        // return false
        if(list)
            setIsLoading(true)
            await savePostClosure(list)
            setIsLoading(false)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (postClosureDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(postClosureDetails?.message)
        } else if (postClosureDetails?.status !== undefined && postClosureDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(postClosureDetails?.message)
        }
    }, [postClosureDetails])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={`activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Post Closure"}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                            <h1 className="h3 mb-0 text-black-100"><b>Post-Closure</b></h1>
                                        </div>
                                            <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                        <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                                handleInput('next_activity_id', 29, "", e)
                                                            }} required={'yes'}>
                                                            <option value="">Select Next Activity
                                                            </option>
                                                            <option
                                                                value={29}>Post-Closure</option>
                                                        </select>
                                                        <label className="large-label float-lb">
                                                            Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                        <input type="date"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   handleInput('activity_date', e.target.value, e)
                                                               }}
                                                               id="validationCustom01"
                                                               required={true}
                                                               min={new Date().toISOString().split('T')[0]}
                                                        />
                                                        <label className="large-label float-lb">
                                                            Date <i className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-1 d-mtk-2 float-field">
                                                        <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                                handleInput('meta_data', e.target.value, "Reason_of_meeting", e)
                                                            }} required>
                                                            <option value="">Select Reason of meeting
                                                            </option>
                                                            <option value="Cross sell/Upsell">Cross sell/Upsell
                                                            </option>
                                                            <option value="Ops Issue">Ops Issue
                                                            </option>
                                                            <option
                                                                value="Tech Issue">Tech Issue
                                                            </option>
                                                        </select>
                                                        <label className="large-label float-lb">
                                                            Reason of meeting <i className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mt-2 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Description*"
                                                                    onChange={(e) => {
                                                                        handleInput('desc', e.target.value, '', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                        <label className="large-label float-lb">
                                                            {/*Remark*/}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-4 d-flex">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )

}

export default PostClosure